import { render, staticRenderFns } from "./SuperDocWelcome.vue?vue&type=template&id=6368caf2&scoped=true"
import script from "./SuperDocWelcome.vue?vue&type=script&lang=js"
export * from "./SuperDocWelcome.vue?vue&type=script&lang=js"
import style0 from "./SuperDocWelcome.vue?vue&type=style&index=0&id=6368caf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368caf2",
  null
  
)

export default component.exports